import { Routes, Route, Navigate } from "react-router-dom";
import AdminLayout from "./AdminLayout";
import AdminUsers from "./AdminUsers";
import AdminTutors from "./AdminTutors";
import AdminRequests from "./AdminRequests";
import AdminBookings from "./AdminBookings";
import AdminWallets from "./AdminWallets";
import AdminTransactions from "./AdminTransactions";
import AdminLogs from "./AdminLogs";
import AdminAudit from "./AdminAudit";
import AdminDisputes from "./AdminDisputes";
import AdminRequestDisputes from "./AdminRequestDisputes";
import AdminContacts from "./AdminContacts";
import AdminCredentials from "./AdminCredentials";


export default function AdminRouter() {
  return (
    <AdminLayout>
      <Routes>
        <Route index element={<Navigate to="users" replace />} />
        <Route path="users" element={<AdminUsers />} />
        <Route path="tutors" element={<AdminTutors />} />
        <Route path="credentials" element={<AdminCredentials />} />
        <Route path="requests" element={<AdminRequests />} />
        <Route path="requests/:id" element={<AdminRequests />} />
        <Route path="bookings" element={<AdminBookings />} />
        <Route path="disputes" element={<AdminDisputes />} />
        <Route path="request-disputes" element={<AdminRequestDisputes />} />
        <Route path="wallets" element={<AdminWallets />} />
        <Route path="transactions" element={<AdminTransactions />} />
        <Route path="contacts" element={<AdminContacts />} />
        <Route path="logs" element={<AdminLogs />} />
        <Route path="audit" element={<AdminAudit />} />
        <Route path="*" element={<div className="p-6 text-white/70">Not Found</div>} />
      </Routes>
    </AdminLayout>
  );
}
